module.exports = __webpack_public_path__ + "img/L_315_325.c19d0a7d.png";